// Import components
import React, { useMemo, useState } from "react";
import Breadcrumbs from '../../../Components/Common/Breadcrumb';
import TableContainer from '../../../Components/Common/TableContainer';
import { Modal, Label, ModalHeader, Card, CardBody, Row, Col, Alert, CardHeader, Badge, Button } from 'reactstrap';
import defaultUserImg from "../../../assets/images/defaultuserimgdark.png";
import axios from "axios";
import { useEffect } from "react";
import { Link } from "react-router-dom";

interface column {
    header: string;
    accessorKey?: string;
    accessorFn?: (row: any) => string;
    enableColumnFilter: boolean;
    enableSorting: boolean;
    cell?: (info: any) => React.ReactNode;
}

const AdminValues = () => {

    const [showloader, setshowloader] = useState(true);
    const [alertMsgg, setAlertMsgg] = useState<any>({ open: false, type: "success", content: "Messages here.", time: "2500" });

    const [addAdminValueModal, setAddAdminValueModal] = useState(false);
    const [deleteAdminValueModal, setDeleteAdminValueModal] = useState(false);

    const [adminValues, setAdminValues] = useState<any>([]);
    const [allowedKeys, setAllowedKeys] = useState<{ name: string; label: string; description: string; is_set: boolean }[]>([]);

    const [adminValueDetails, setAdminValueDetails] = useState<any>({
        name: "",
        value: "",
        description: "",
    });

    const handleAlertMsggClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === "clickaway") { return; }
        setAlertMsgg({ ...alertMsgg, open: false });
    };

    const fetch_adminValues = async () => {
        try {
            setshowloader(true);
            const response = await axios.get(
                `/accounts/list_admin_values`,
                {
                },
                { withCredentials: true }
            );
            if (response && response.status === "SENT") {
                setAdminValues(response.admin_values || []);
                setAllowedKeys(response.allowed_keys || []);
            }
            setshowloader(false);
        } catch (error: any) {
            if (error.response) {
                if ([401, 422].includes(error.response.status)) {
                    setAlertMsgg({ ...alertMsgg, open: true, content: error.response.data?.error || "Error occurred", type: "error" });
                } else if (error.response.status === 403) {
                    setAlertMsgg({ ...alertMsgg, open: true, content: "Session expired!", type: "error" });
                    setTimeout(() => { window.location.href = "/logout"; }, 2000);
                } else {
                    setAlertMsgg({ ...alertMsgg, open: true, content: "An error occurred", type: "error" });
                }
            } else {
                setAlertMsgg({ ...alertMsgg, open: true, content: "Network error", type: "error" });
            }
            setshowloader(false);
        }
    };

    useEffect(() => {
        fetch_adminValues();
    }, []);

    function removeBodyCss() {
        document.body.classList.add("no_padding");
    }

    function toggleDeleteAdminValueModal() {
        setDeleteAdminValueModal(!deleteAdminValueModal);
        removeBodyCss();
    }

    const toggleAddUpdateAdminValueModal = () => {
        setAddAdminValueModal(!addAdminValueModal);
        removeBodyCss();
    }

    const handleAdminValue = async (operation = "create") => {
        // For create/update, ensure required fields are present
        console.log("Admin Value Details:", adminValueDetails, "Operation:", operation);
        
        if (
            (operation === "create" || operation === "update") &&
            (!adminValueDetails.name)
        ) {
            setAlertMsgg({ ...alertMsgg, open: true, content: "Please select assignment and enter adminValue name.", type: "error" });
            return;
        }

        // For delete, ensure adminValue_id is present
        if ((operation === "delete" || operation === "update") && !adminValueDetails["id"]) {
            setAlertMsgg({ ...alertMsgg, open: true, content: "No adminValue selected for deletion.", type: "error" });
            return;
        }

        // Prepare payload
        let payload = {};
        if (operation === "create") {
            payload = {
                name: adminValueDetails.name,
                description: adminValueDetails.description || "",
                value: adminValueDetails.value || "",
            };
        } else if (operation === "update") {
            payload = {
                adminValue_id: adminValueDetails.id,
                name: adminValueDetails.name,
                description: adminValueDetails.description || "",
                value: adminValueDetails.value || ""
            };
        } else if (operation === "delete") {
            payload = {
                adminValue_id: adminValueDetails.id,
                todelete: true
            };
        }

        try {
            setshowloader(true);
            const response = await axios.post(
                "/accounts/manage_admin_value",
                payload,
                { withCredentials: true }
            );
            if (response && (response.status === "CREATED" || response.status === "UPDATED" || response.status === "DELETED")) {
                setAlertMsgg({ ...alertMsgg, open: true, content: `Admin Value ${operation}d successfully.`, type: "success" });
                fetch_adminValues();
                // Optionally reset form fields here
            } else {
                setAlertMsgg({ ...alertMsgg, open: true, content: `Failed to ${operation} admin value.`, type: "error" });
            }
            setshowloader(false);
        } catch (error: any) {
            console.log(error);

            if (error.response) {
                setAlertMsgg({ ...alertMsgg, open: true, content: error.response.data?.error || "Error occurred", type: "error" });
            } else {
                setAlertMsgg({ ...alertMsgg, open: true, content: "Network error", type: "error" });
            }
            setshowloader(false);
        }
    };

    document.title = "Admin Values | BizServe";

    const adminValueTableColumn: column[] = useMemo(
        () => [
            {
                header: 'S No.',
                enableColumnFilter: false,
                enableSorting: false,
                cell: ({ row }) => <>{`${row.index + 1}`}</>,
            },
            {
                header: 'Name',
                enableColumnFilter: false,
                enableSorting: true,
                cell: ({ row }) => {
                    const name = row.original.name;

                    return (
                        <div className="d-flex align-items-center">
                            <div>
                                <div className="fw-medium">{name}</div>
                            </div>
                        </div>
                    );
                },
            },
            {
                header: 'Value',
                enableColumnFilter: false,
                enableSorting: true,
                cell: ({ row }) => {

                    const value = row.original.value;

                    return (
                        <div className="d-flex align-items-center">
                            <div>
                                <div className="fw-medium">{value}</div>
                            </div>
                        </div>
                    );
                },
            },
            {
                header: 'Description',
                enableColumnFilter: false,
                enableSorting: true,
                cell: ({ row }) => {

                    const desc = row.original.description;

                    return (
                        <div className="d-flex align-items-center">
                            <div>
                                <div className="fw-medium">{desc}</div>
                            </div>
                        </div>
                    );
                },
            },
            {
                header: 'Action',
                enableColumnFilter: false,
                enableSorting: true,
                cell: ({ row }) => {
                    const admValue = row.original;
                    return (
                        <div className="d-flex gap-2">
                            <Button color="dark" className="btn btn-sm me-2 mb-sm-0 mb-2" data-toggle="button" aria-pressed="false" onClick={() => { setAdminValueDetails({ ...admValue }); toggleAddUpdateAdminValueModal(); }}> <i className="bx bx-pencil font-size-11 align-middle"></i></Button>
                            <Button color="danger" className="btn btn-primary btn-sm me-2 mb-sm-0 mb-2" data-toggle="button" aria-pressed="false" onClick={() => { setAdminValueDetails({ id: admValue.id }); toggleDeleteAdminValueModal(); }}> <i className="bx bx-trash font-size-11 align-middle"></i></Button>
                        </div>
                    );
                },
            }
        ],
        []
    );

    return (
        <div className="page-content">
            <div className="container-fluid">
                <Breadcrumbs title="Admin" breadcrumbItem="Admin Values" />
                {alertMsgg.open && (
                    <Alert
                        color={alertMsgg.type === "success" ? "success" : "danger"}
                        toggle={handleAlertMsggClose}
                        fade={false}
                        style={{ fontWeight: "bold" }}
                    >
                        {alertMsgg.content}
                    </Alert>
                )}
                <div className="loaderContainer" hidden={!showloader}>
                    <div className="spinner">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>
                <Row>
                    <Col md={12} className="d-flex justify-content-end align-items-center mb-3">
                        <button
                            type="button"
                            className="btn btn-primary "
                            onClick={() => {
                                setAdminValueDetails({
                                    name: "",
                                    description: ""
                                });
                                toggleAddUpdateAdminValueModal();
                            }}
                        >
                           + Add Admin Value
                        </button>
                    </Col>
                    <Col md={12}>
                        <Row>
                            {adminValues && (
                                <Col className="" md={12}>
                                    <Card className="rounded-4 border border-dark-shade card overflow-hidden">
                                        <CardBody>
                                            <Row>

                                                <TableContainer
                                                    columns={adminValueTableColumn}
                                                    data={adminValues || []}
                                                    isGlobalFilter={false}
                                                    isPagination={false}
                                                    SearchPlaceholder="Search By Name..."
                                                    tableClass="table-bordered dt-responsive table-nowrap w-100 dataTable no-footer dtr-inline"
                                                />
                                            </Row>
                                        </CardBody>
                                    </Card>
                                </Col>
                            )}
                        </Row>
                    </Col>
                </Row>

                {/* Add/Update AdminValue */}
                <Modal
                    isOpen={addAdminValueModal}
                    size="lg"
                    toggle={toggleAddUpdateAdminValueModal}
                    backdrop={'static'}
                    centered
                >
                    <ModalHeader toggle={toggleAddUpdateAdminValueModal}>
                        <div className="modal-title mt-0 font-size-16 text-dark">
                            {adminValueDetails && adminValueDetails.id ? "Edit Admin Value" : "Add Admin Value"}
                        </div>
                    </ModalHeader>
                    <div className="modal-body">
                        <form>
                            <Row>
                                <Col lg={12}>
                                    <div className="mb-3">
                                        <label className="form-label">Name</label>
                                        {adminValueDetails.id ? (
                                            <>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={adminValueDetails.name}
                                                    disabled
                                                />
                                                {allowedKeys.find(k => k.name === adminValueDetails.name)?.description && (
                                                    <small className="text-muted mt-1 d-block">
                                                        {allowedKeys.find(k => k.name === adminValueDetails.name)?.description}
                                                    </small>
                                                )}
                                            </>
                                        ) : (
                                            <>
                                                <select
                                                    className="form-select"
                                                    value={adminValueDetails.name}
                                                    onChange={e =>
                                                        setAdminValueDetails({ ...adminValueDetails, name: e.target.value })
                                                    }
                                                >
                                                    <option value="">-- Select a key --</option>
                                                    {allowedKeys
                                                        .filter(k => !k.is_set)
                                                        .map(k => (
                                                            <option key={k.name} value={k.name}>{k.label}</option>
                                                        ))
                                                    }
                                                </select>
                                                {adminValueDetails.name && allowedKeys.find(k => k.name === adminValueDetails.name)?.description && (
                                                    <small className="text-muted mt-1 d-block">
                                                        {allowedKeys.find(k => k.name === adminValueDetails.name)?.description}
                                                    </small>
                                                )}
                                            </>
                                        )}
                                    </div>
                                </Col>
                                <Col lg={12}>
                                    <div className="mb-3">
                                        <label className="form-label">Value</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={adminValueDetails.value}
                                            onChange={e =>
                                                setAdminValueDetails({ ...adminValueDetails, value: e.target.value })
                                            }
                                            placeholder="Enter value"
                                        />
                                    </div>
                                </Col>
                                <Col lg={12}>
                                    <div className="mb-3">
                                        <label className="form-label">Description</label>
                                        <textarea
                                            className="form-control"
                                            value={adminValueDetails.description}
                                            onChange={e =>
                                                setAdminValueDetails({ ...adminValueDetails, description: e.target.value })
                                            }
                                            placeholder="Enter description"
                                        />
                                    </div>
                                </Col>
                                <Col lg={12}>
                                    <div className="d-flex justify-content-end">
                                        <button
                                            className="btn btn-primary mb-3"
                                            type="button"
                                            onClick={() => {
                                                if (adminValueDetails && adminValueDetails.id) {
                                                    handleAdminValue("update");
                                                } else {
                                                    handleAdminValue("create");
                                                }
                                                toggleAddUpdateAdminValueModal();
                                            }}
                                        >
                                            {adminValueDetails && adminValueDetails.id ? "Update Admin Value" : "Add Admin Value"}
                                        </button>
                                    </div>
                                </Col>
                            </Row>
                        </form>
                    </div>
                </Modal>

                {/* Delete AdminValue */}
                <Modal
                    isOpen={deleteAdminValueModal}
                    toggle={() => {
                        toggleDeleteAdminValueModal();
                    }}
                    centered
                    className="rounded-4"
                >
                    <ModalHeader className="py-3 px-4" toggle={() => { toggleDeleteAdminValueModal(); }}>
                        <div className="modal-title mt-0 font-size-16 text-dark">
                            Delete AdminValue
                        </div>
                    </ModalHeader>

                    <div className="modal-body">
                        <p>Are you sure you want to delete this admin value?</p>
                    </div>

                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-sm btn-soft-dark"
                            onClick={() => { toggleDeleteAdminValueModal(); }}
                        >
                            Cancel
                        </button>
                        <button
                            type="button"
                            className="btn btn-sm btn-danger"
                            onClick={() => {
                                handleAdminValue("delete");
                                toggleDeleteAdminValueModal();
                            }}
                        >
                            Delete
                        </button>
                    </div>
                </Modal>

            </div>
        </div>
    );
};

export default AdminValues;
